import { Application } from '@hotwired/stimulus'

const application = Application.start()

const controllers = import.meta.glob("./**/*_controller.{js,ts}", {
  eager: true,
})

for (const [path, module] of Object.entries(controllers)) {
  const identifier = path
    .replace("./", "")
    .replace(/_controller\.(js|ts)$/, "")
    .replace(/\//g, "--")
    .replace(/_/g, "-")

  application.register(identifier, module.default)
}
